import module from 'contabilidad/polizasexternas/module'

const schema = {
  fecha: 'date',
  totalDebe: 'number',
  totalHaber: 'number',
  detalles: {
    importe: 'number',
  },
}

export class PolizaExternasAlgodonerosPagosComprasService {
  constructor($http) {
    this.$http = $http
  }

  get(busqueda) {
    return this.$http.get('/api/contabilidad/polizasexternas/algodoneros/pagos-compras', {
      params: {
        fechaInicio: busqueda.fechaInicio.toYMD(),
        fechaFinal: busqueda.fechaFin.toYMD(),
      },
      schema,
    })
  }
}

module.service('PolizaExternasAlgodonerosPagosComprasService', PolizaExternasAlgodonerosPagosComprasService)




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/Algodoneros/PagosCompras.js